export default {
  // 用水户信息
  hno: {
    label: '户号',
    type: 'input',
    width: 100,
    form: {
      type: 'input',
      like: true,
      size: 10
    },
    filter: {
      type: 'input',
      like: true,
      width: 100
    }
  },
  hname: {
    label: '户名',
    type: 'input',
    width: 100,
    form: {
      type: 'input',
      size: 10
    },
    filter: {
      type: 'input',
      like: true,
      width: 100
    }
  },
  addr: {
    label: '地址',
    width: 200,
    size: 16,
    labelSize: 4,
    isWrap: true,
    form: {
      type: 'text',
      size: 24
    }
  },
  phone: {
    label: '固话',
    size: 8,
    width: 120,
    form: {
      type: 'input',
      size: 10
    }
  },
  mobile: {
    label: '联系手机',
    size: 8,
    width: 120,
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'numeric', message: '输入正确的手机号' }]
    }
  },
  counterCode: {
    label: '计量器编号',
    width: 150,
    filter: {
      type: 'input',
      like: true,
      width: 150
    },
    form: {
      type: 'input',
      size: 12,
      rules: [{
        type: 'required',
        message: '请输入设备编号'
      }]
    },
    style: {
      'text-align': 'center'
    }
  },
  code: {
    label: '点抄结果',
    width: 100,
    type: 'select',
    filter: {
      type: 'select',
      width: 100
    },
    form: {
      type: 'input',
      size: 12,
      rules: [{
        type: 'required',
        message: '请输入设备编号'
      }]
    },
    style: {
      textAlign: 'center'
    },
    options: [{
      label: '成功', value: 'success'
    }, {
      label: '失败', value: 'failed'
    }]
  },
  result: {
    label: '点抄结果',
    width: 100,
    type: 'select',
    filter: {
      type: 'select',
      width: 100
    },
    form: {
      type: 'input',
      size: 12,
      rules: [{
        type: 'required',
        message: '请输入设备编号'
      }]
    },
    style: {
      textAlign: 'center'
    },
    options: [{
      label: '成功', value: 'success'
    }, {
      label: '失败', value: 'failed'
    }]
  },
  lnum: {
    label: '上期行码',
    width: 100,
    style: {
      textAlign: 'center'
    }
  },
  lquanty: {
    label: '上期水量',
    width: 100,
    style: {
      textAlign: 'center'
    }
  },
  num: {
    label: '本期行码',
    width: 100,
    style: {
      textAlign: 'center'
    },
    form: {
      type: 'input',
      rules: [{ type: 'numeric', message: '输入正确的行码' }]
    }
  },
  quanty: {
    label: '本期水量',
    width: 100,
    style: {
      textAlign: 'center'
    }
  },
  status: {
    label: '状态',
    size: 8,
    width: 100,
    filter: {
      type: 'select'
    }
  },
  dataType: {
    label: '点抄类型',
    type: 'select',
    filter: {
      type: 'select'
    },
    form: {
      type: 'select'
    },
    style: {
      textAlign: 'center'
    },
    options: [{
      label: '全部', value: 'all'
    }, {
      label: '点抄', value: 'click_reading'
    }, {
      label: '定抄', value: 'timing_reading'
    }]
  },
  type: {
    label: '点抄类型',
    type: 'select',
    filter: {
      type: 'select'
    },
    form: {
      type: 'select'
    },
    style: {
      textAlign: 'center'
    },
    options: [{
      label: '全部', value: 'all'
    }, {
      label: '点抄', value: 'click_reading'
    }, {
      label: '定抄', value: 'timing_reading'
    }]
  },
  excuteResult: {
    label: '点抄结果',
    // width: 100,
    // style: {
    //   textAlign: 'center'
    // },
    filter: {
      type: 'select'
    },
    form: {
      type: 'select'
    },
    options: [{
      label: '全部', value: 'all'
    }, {
      label: '成功', value: 'success'
    }, {
      label: '失败', value: 'failure'
    }]
  },
  areaId: {
    label: '计量器区域',
    relation: 'areaId',
    type: 'select',
    width: 150,
    filter: {
      type: 'cascader',
      onlySelectLeaf: false,
      width: 120
    },
    form: {
      type: 'cascader',
      onlySelectLeaf: false,
      size: 10,
      rules: [{ type: 'required', message: '请选择对应的区域' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  areaPathName: {
    label: '计量器区域',
    type: 'input'
  },
  // 时间
  time: {
    label: '抄表时间',
    type: 'time',
    width: 180,
    // size: 8,
    dataType: 'YYYY-MM-DD',
    filter: {
      type: 'daterange'
    },
    form: {
      type: 'date',
      rules: [
        { type: 'number', required: true, message: '请选择开始时间', trigger: 'change' }
      ]
    }
  },
  copyTime: {
    label: '冻结时间',
    type: 'time',
    width: 180,
    size: 8,
    dataType: 'YYYY-MM-DD',
    filter: {
      type: 'daterange'
    },
    form: {
      type: 'date',
      rules: [
        { type: 'number', required: true, message: '请选择开始时间', trigger: 'change' }
      ]
    }
  },
  startTimeStamp: {
    label: '开始时间',
    type: 'time',
    dataType: 'YYYY-MM-DD',
    filter: {
      type: 'date'
    },
    form: {
      type: 'date'
    }
  },
  endTimeStamp: {
    label: '结束时间',
    type: 'time',
    dataType: 'YYYY-MM-DD',
    filter: {
      type: 'date'
    },
    form: {
      type: 'date'
    }
  },
  year: {
    label: '年份',
    type: 'date',
    dateType: 'year',
    filter: {
      type: 'date',
      dateType: 'year'
    },
    form: {
      type: 'date',
      dateType: 'year',
      placeholder: '选择年份'
    }
  },
  period: {
    label: '周期',
    width: 175,
    type: 'time',
    dataType: 'YYYY-MM-DD',
    filter: {
      type: 'daterange',
      width: 200
    }
  },
  counterId: {
    label: '计量器',
    width: 100,
    type: 'select'
  },
  cost: {
    label: '水费',
    width: 80,
    style: {
      textAlign: 'center'
    }
  },
  wave: {
    label: '波动',
    width: 120,
    filter: {
      type: 'input',
      width: 100,
      suffix: {
        type: 'default',
        text: '%'
      },
      rules: [{ type: 'mixNumfloat', message: '只允许输入整数、浮点数' }]
    }
  },
  readingStatus: {
    label: '点抄状态',
    type: 'select',
    width: 100,
    options: [{
      label: '允许点抄',
      value: 'ready'
    }, {
      label: '正在点抄',
      value: 'processing'
    }, {
      label: '点抄失败',
      value: 'failed'
    }, {
      label: '点抄成功',
      value: 'finish'
    }]
  },
  backfillTime: {
    label: '回填时间'
  }
}



// WEBPACK FOOTER //
// ./src/containers/TelnetReading/waterColumns.js